import { Icon } from 'src/components/Icons';
import styled from 'styled-components';

export const IconStyled = styled(Icon)`
  font-size: 1.5em;
`;
